module.exports = __webpack_public_path__ + "static/img/clubSocialResponsive.c56fddd2.jpg";